export default "__VITE_ASSET__DMCiXaoE__"